module.exports = __webpack_public_path__ + "static/media/robot-prod.3bcac1e5.png";